// import React, { useState } from 'react'
// import { Eye, EyeOff, Loader2, Mail, MoveRight } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';
// import { useToast } from '../../context/ToastContext';

// const LoginPage = () => {

//     const navigate = useNavigate();
//     const [loading, setLoading] = useState(false);

//     const [formData, setFormData] = useState({
//         email: "",
//         password: "",
//     });

//     const [errors, setErrors] = useState({});
//     const [showPassword, setShowPassword] = useState(false);

//     const { success } = useToast();

//     // Handle input change
//     const handleChange = (e) => {
//         setFormData({
//             ...formData,
//             [e.target.name]: e.target.value,
//         });

//         // Clear error when typing
//         setErrors({
//             ...errors,
//             [e.target.name]: "",
//         });
//     };

//     // Validate form
//     const validate = () => {
//         let newErrors = {};

//         if (!formData.email) {
//             newErrors.email = "Email is required";
//         } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
//             newErrors.email = "Enter a valid email address";
//         }

//         if (!formData.password) {
//             newErrors.password = "Password is required";
//         } else if (formData.password.length < 6) {
//             newErrors.password = "Password must be at least 6 characters";
//         }

//         return newErrors;
//     };

//     // Submit
//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         const validationErrors = validate();

//         if (Object.keys(validationErrors).length > 0) {
//             setErrors(validationErrors);
//             return;
//         }


//         try {
//             setLoading(true);

//             // 🔥 Replace with real login API
//             await new Promise((resolve) => setTimeout(resolve, 1500));

//             console.log("Login success:", formData);

//             setTimeout(() => {
//                 setLoading(false);
//                 success("Login successful",);
//                 navigate("/dashboard");

//             }, 1500);

//         } catch (error) {
//             error(error || "Login failed");
//         }
//     };

//     return (
//         <div className="min-h-screen bg-gradient-to-br from-gray-100 via-gray-200 to-gray-300 flex items-center justify-center px-1">

//             <div className="absolute inset-0  bg-gradient-to-br from-white via-indigo-50 to-pink-50"></div>

//             <div className="absolute inset-0  overflow-hidden">
//                 <div className="absolute w-[700px] h-[700px] bg-indigo-200/50 rounded-full blur-[140px] top-[-300px] left-[-200px] animate-float-slow"></div>
//                 <div className="absolute w-[600px] h-[600px] bg-pink-200/40 rounded-full blur-[140px] bottom-[-300px] right-[-150px] animate-float-slower"></div>
//             </div>

//             <div className="absolute inset-0 bg-[linear-gradient(to_right,#00000005_1px,transparent_1px),linear-gradient(to_bottom,#00000005_1px,transparent_1px)] bg-[size:60px_60px]"></div>



//             {/* Card */}
//             <div className="w-full max-w-lg backdrop-blur-lg bg-white/80 shadow-2xl rounded-3xl p-8 border border-gray-200">

//                 {/* Logo */}
//                 <div className="flex justify-center items-center gap-2 mb-8">
//                     <div className="w-10 h-10  flex items-center justify-center">
//                         <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-tv h-8 w-8 text-black" aria-hidden="true"><path d="m17 2-5 5-5-5"></path><rect width="20" height="15" x="2" y="7" rx="2"></rect></svg>
//                     </div>
//                     <h1 className="text-3xl font-semibold text-gray-900">
//                         SocialTV
//                     </h1>
//                 </div>

//                 {/* Heading */}
//                 <h2 className="text-2xl font-semibold text-gray-900 mb-2">
//                     Sign in
//                 </h2>
//                 <p className="text-sm text-gray-500 mb-6">
//                     Turn your social content into high-impact 4K TV ads.
//                 </p>
//                 {/* <p className="text-gray-500 mb-6">
//                     Login to continue creating stunning 4K TV ads.
//                 </p> */}

//                 {/* Form */}
//                 <form className="space-y-5" onSubmit={handleSubmit}>

//                     {/* Email */}
//                     <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                             Email
//                         </label>
//                         <div className="relative">
//                             <input
//                                 type="text"
//                                 name="email"
//                                 value={formData.email}
//                                 onChange={handleChange}
//                                 placeholder="Enter Your Email"
//                                 className={`w-full px-4 py-3 rounded-xl border 
//                                         ${errors.email ? "border-red-500" : "border-gray-300"}
//                                         focus:ring-1 focus:ring-black focus:border-black 
//                                         outline-none transition`}
//                             />
//                             <div className='absolute right-4 top-1/2 -translate-y-1/2 text-gray-500'>
//                                 <Mail size={20} />
//                             </div>
//                         </div>
//                         {errors.email && (
//                             <p className="text-red-500 text-sm mt-1">
//                                 {errors.email}
//                             </p>
//                         )}
//                     </div>

//                     {/* Password */}
//                     <div>
//                         <label className="block text-sm font-medium text-gray-700 mb-2">
//                             Password
//                         </label>

//                         <div className="relative">
//                             <input
//                                 type={showPassword ? "text" : "password"}
//                                 name="password"
//                                 value={formData.password}
//                                 onChange={handleChange}
//                                 placeholder="Enter Your Password"
//                                 className={`w-full px-4 py-3 rounded-xl border pr-12
//                                             ${errors.password ? "border-red-500" : "border-gray-300"}
//                                             focus:ring-1 focus:ring-black focus:border-black 
//                                             outline-none transition`}
//                             />

//                             {/* Toggle Icon */}
//                             <button
//                                 type="button"
//                                 onClick={() => setShowPassword(!showPassword)}
//                                 className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500"
//                             >
//                                 {showPassword ? <Eye size={20} /> : <EyeOff size={20} />}
//                             </button>
//                         </div>

//                         {errors.password && (
//                             <p className="text-red-500 text-sm mt-1">
//                                 {errors.password}
//                             </p>
//                         )}
//                     </div>

//                     <div className="flex justify-end !mt-3">
//                         <button
//                             type="button"
//                             onClick={() => navigate("/forgot-password")}
//                             className="text-sm text-gray-600 hover:text-black hover:underline transition"
//                         >
//                             Forgot Password?
//                         </button>
//                     </div>

//                     {/* Login Button */}
//                     <button
//                         type="submit"
//                         disabled={loading}
//                         className="w-full flex justify-center items-center gap-2 bg-black text-white py-3 rounded-xl hover:bg-gray-900 transition font-medium disabled:opacity-70 disabled:cursor-not-allowed"
//                     >
//                         {loading ? (
//                             <>
//                                 <Loader2 className="animate-spin" size={18} />
//                                 Signing in...
//                             </>
//                         ) : (
//                             <>
//                                 <span>Sign In</span>
//                                 <MoveRight size={16} />
//                             </>
//                         )}
//                     </button>


//                 </form>

//                 {/* Divider */}
//                 <div className="flex items-center gap-3 my-4">
//                     <div className="flex-1 h-px bg-gray-200" />
//                     <span className="text-gray-400 text-sm">OR</span>
//                     <div className="flex-1 h-px bg-gray-200" />
//                 </div>

//                 {/* Secondary Button */}
//                 <button
//                     type="button"
//                     className="w-full border border-gray-300 py-3 rounded-xl  hover:bg-gray-50 transition font-medium"
//                     onClick={() => navigate("/sign-up")}
//                 >
//                     Create an Account
//                 </button>
//             </div>
//         </div>
//     );
// };

// export default LoginPage

import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../context/ToastContext';
import {
    Eye,
    EyeOff,
    Loader2,
    Mail,
    MoveRight,
    Sparkles,
    Shield,
    Zap,
} from 'lucide-react';

const LoginPage = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [mounted, setMounted] = useState(false);

    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });

    const [errors, setErrors] = useState({});
    const [showPassword, setShowPassword] = useState(false);
    const [focusedField, setFocusedField] = useState(null);

    const { success } = useToast();

    useEffect(() => {
        setMounted(true);
    }, []);

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
        setErrors({
            ...errors,
            [e.target.name]: "",
        });
    };

    const validate = () => {
        let newErrors = {};
        if (!formData.email) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = "Enter a valid email address";
        }
        if (!formData.password) {
            newErrors.password = "Password is required";
        } else if (formData.password.length < 6) {
            newErrors.password = "Password must be at least 6 characters";
        }
        return newErrors;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        try {
            setLoading(true);
            await new Promise((resolve) => setTimeout(resolve, 1500));
            console.log("Login success:", formData);
            setTimeout(() => {
                setLoading(false);
                success("Welcome back! Redirecting to dashboard...");
                navigate("/dashboard");
            }, 1500);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-indigo-50 via-white to-purple-50 flex items-center justify-center p-4 relative overflow-hidden">

            {/* Soft Background Elements */}
            {/* <div className="absolute inset-0 overflow-hidden">
                <div className={`absolute w-[800px] h-[800px] bg-indigo-200/30 rounded-full blur-[120px] top-[-400px] left-[-200px] transition-all duration-1000 ${mounted ? 'opacity-100' : 'opacity-0'}`}></div>
                <div className={`absolute w-[600px] h-[600px] bg-purple-200/30 rounded-full blur-[120px] bottom-[-300px] right-[-100px] transition-all duration-1000 delay-300 ${mounted ? 'opacity-100' : 'opacity-0'}`}></div>

                <div className="absolute inset-0 bg-[linear-gradient(to_right,#f0f0f0_1px,transparent_1px),linear-gradient(to_bottom,#f0f0f0_1px,transparent_1px)] bg-[size:40px_40px]"></div>
            </div> */}

            <div className="absolute inset-0 overflow-hidden">
                <div className={`absolute w-[800px] h-[800px] rounded-full bg-indigo-300/20 blur-[160px] top-[-500px] left-[-300px] transition-all duration-1000 ${mounted ? 'opacity-100' : 'opacity-0'}`}></div>
                <div className={`absolute w-[800px] h-[800px] rounded-full bg-blue-300/20 blur-[150px] bottom-[-400px] right-[-250px] transition-all duration-1000 delay-300 ${mounted ? 'opacity-100' : 'opacity-0'}`}></div>
                <div className={`absolute w-[700px] h-[700px] rounded-full bg-violet-300/20 blur-[140px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transition-all duration-1000 delay-500 ${mounted ? 'opacity-100' : 'opacity-0'}`}></div>
                <div className={`absolute w-[500px] h-[500px] rounded-full bg-pink-200/25 blur-[120px] top-1/4 right-1/4 transition-all duration-1000 delay-700 ${mounted ? 'opacity-100' : 'opacity-0'}`}></div>
            </div>


            {/* Main Card */}
            <div className={`w-full max-w-5xl relative transition-all duration-1000 transform ${mounted ? 'translate-y-0 opacity-100' : 'translate-y-10 opacity-0'}`}>
                <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-200">
                    <div className="grid md:grid-cols-2">

                        {/* Left Side - Branding & Features */}
                        <div className="relative p-8 md:p-12 bg-gradient-to-br from-indigo-50 to-purple-50 flex flex-col">

                            {/* Logo */}
                            <div className="flex items-center gap-3 mb-8">
                                <div className="w-10 h-10 bg-gradient-to-br from-indigo-500 to-purple-500 rounded-lg flex items-center justify-center shadow-sm">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="m17 2-5 5-5-5"></path>
                                        <rect width="20" height="15" x="2" y="7" rx="2"></rect>
                                    </svg>
                                </div>
                                <h1 className="text-2xl font-semibold text-gray-800">
                                    SocialTV
                                </h1>
                            </div>

                            {/* Hero Text */}
                            <div className="relative z-10">
                                <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4 leading-tight">
                                    Turn your social<br />
                                    <span className="text-indigo-600">
                                        into TV ads
                                    </span>
                                </h2>
                                <p className="text-gray-600 mb-8 leading-relaxed">
                                    Create stunning 4K TV ads from your social media content in minutes. Simple, fast, and effective.
                                </p>

                                {/* Feature List - Minimal */}
                                <div className="space-y-3">
                                    {[
                                        { icon: Zap, text: "AI-powered optimization" },
                                        { icon: Sparkles, text: "4K quality exports" },
                                        { icon: Shield, text: "Secure & private" }
                                    ].map((feature, index) => (
                                        <div key={index} className="flex items-center gap-3 text-gray-700">
                                            <feature.icon size={18} className="text-indigo-500" />
                                            <span className="text-sm">{feature.text}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Login Form */}
                        <div className="p-8 md:p-12 bg-white">
                            {/* Form Header */}
                            <div className="mb-6">
                                <h3 className="text-2xl font-semibold text-gray-800 mb-1">
                                    Welcome back
                                </h3>
                                <p className="text-gray-500 text-sm">
                                    Please enter your details to sign in
                                </p>
                            </div>

                            {/* Form */}
                            <form className="space-y-5" onSubmit={handleSubmit}>
                                {/* Email */}
                                <div className="space-y-1.5">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Email
                                    </label>
                                    <div className="relative">
                                        <input
                                            type="text"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            onFocus={() => setFocusedField('email')}
                                            onBlur={() => setFocusedField(null)}
                                            placeholder="Enter your email"
                                            className={`w-full px-4 py-2.5 rounded-lg border transition-all duration-200
                                                ${errors.email
                                                    ? "border-red-300 bg-red-50/50"
                                                    : focusedField === 'email'
                                                        ? "border-indigo-300 bg-indigo-50/30"
                                                        : "border-gray-200 bg-gray-50"
                                                }
                                                outline-none focus:ring-1 
                                                ${errors.email
                                                    ? "focus:ring-red-100"
                                                    : "focus:ring-indigo-100"
                                                }
                                                pr-10 text-sm`}
                                        />
                                        <Mail className={`absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 transition-colors
                                            ${errors.email
                                                ? "text-red-400"
                                                : focusedField === 'email'
                                                    ? "text-indigo-400"
                                                    : "text-gray-400"
                                            }`}
                                        />
                                    </div>
                                    {errors.email && (
                                        <p className="text-red-500 text-xs mt-1">
                                            {errors.email}
                                        </p>
                                    )}
                                </div>

                                {/* Password */}
                                <div className="space-y-1.5">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Password
                                    </label>
                                    <div className="relative">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            name="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            onFocus={() => setFocusedField('password')}
                                            onBlur={() => setFocusedField(null)}
                                            placeholder="Enter your password"
                                            className={`w-full px-4 py-2.5 rounded-lg border transition-all duration-200
                                                ${errors.password
                                                    ? "border-red-300 bg-red-50/50"
                                                    : focusedField === 'password'
                                                        ? "border-indigo-300 bg-indigo-50/30"
                                                        : "border-gray-200 bg-gray-50"
                                                }
                                                outline-none focus:ring-1 
                                                ${errors.password
                                                    ? "focus:ring-red-100"
                                                    : "focus:ring-indigo-100"
                                                }
                                                pr-10 text-sm`}
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                            className={`absolute right-3 top-1/2 -translate-y-1/2 transition-colors
                                                ${focusedField === 'password'
                                                    ? "text-indigo-400"
                                                    : "text-gray-400 hover:text-gray-600"
                                                }`}
                                        >
                                            {showPassword ? <Eye size={16} /> : <EyeOff size={16} />}
                                        </button>
                                    </div>
                                    {errors.password && (
                                        <p className="text-red-500 text-xs mt-1">
                                            {errors.password}
                                        </p>
                                    )}
                                </div>

                                {/* Forgot Password */}
                                <div className="flex items-center justify-between">
                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input type="checkbox" className="w-3.5 h-3.5 rounded border-gray-300 text-indigo-600 focus:ring-indigo-200" />
                                        <span className="text-xs text-gray-600">
                                            Remember me
                                        </span>
                                    </label>
                                    <button
                                        type="button"
                                        onClick={() => navigate("/forgot-password")}
                                        className="text-xs text-indigo-600 hover:text-indigo-700 hover:underline"
                                    >
                                        Forgot password?
                                    </button>
                                </div>

                                {/* Login Button */}
                                <button
                                    type="submit"
                                    disabled={loading}
                                    className="w-full flex items-center justify-center gap-2 bg-indigo-600 text-white py-2.5 rounded-lg hover:bg-indigo-700 transition-all font-medium text-sm disabled:opacity-70 disabled:cursor-not-allowed"
                                >
                                    {loading ? (
                                        <>
                                            <Loader2 className="animate-spin" size={16} />
                                            Signing in...
                                        </>
                                    ) : (
                                        <>
                                            <span>Sign In</span>
                                            <MoveRight size={16} />
                                        </>
                                    )}
                                </button>

                                {/* Divider */}
                                <div className="relative my-4">
                                    <div className="absolute inset-0 flex items-center">
                                        <div className="w-full border-t border-gray-100"></div>
                                    </div>
                                    <div className="relative flex justify-center text-xs">
                                        <span className="px-3 bg-white text-gray-400">Or</span>
                                    </div>
                                </div>

                                {/* Social Login */}

                                <div className="grid grid-cols-2 gap-3">
                                    {/* Google */}
                                    <button
                                        type="button"
                                        className="flex items-center justify-center gap-2 px-3 py-2 border border-gray-200 rounded-lg hover:bg-gray-50 transition-all text-xs text-gray-600"
                                    >
                                        <svg className="w-4 h-4" viewBox="0 0 48 48">
                                            <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303C33.659 32.657 29.233 36 24 36c-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.277 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z" />
                                            <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 16.108 18.961 13 24 13c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.277 4 24 4c-7.732 0-14.41 4.388-17.694 10.691z" />
                                            <path fill="#4CAF50" d="M24 44c5.177 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.211 0-9.623-3.317-11.283-7.946l-6.522 5.025C9.458 39.556 16.227 44 24 44z" />
                                            <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.767 2.127-2.246 3.963-4.094 5.27l6.19 5.238C36.971 36.205 44 31 44 24c0-1.341-.138-2.65-.389-3.917z" />
                                        </svg>
                                        Google
                                    </button>

                                    {/* Facebook */}
                                    <button
                                        type="button"
                                        className="flex items-center justify-center gap-2 px-3 py-2 border border-gray-200 rounded-lg hover:bg-gray-50 transition-all text-xs text-gray-600"
                                    >
                                        <svg className="w-4 h-4 text-blue-600" viewBox="0 0 24 24" fill="currentColor">
                                            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                                        </svg>
                                        Facebook
                                    </button>
                                </div>

                                {/* Sign Up Link */}
                                <p className="text-center text-xs text-gray-500 mt-4">
                                    Don't have an account?{' '}
                                    <button
                                        type="button"
                                        onClick={() => navigate("/sign-up")}
                                        className="font-medium text-indigo-600 hover:text-indigo-700 hover:underline"
                                    >
                                        Sign up
                                    </button>
                                </p>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;